export default "__VITE_ASSET__DigA8PtY__"